import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AdminMobileTopbar from "./AdminMobileTopbar";
import { useScheduledMeetings } from "./useScheduledMeetings";

const MobileScheduledMeetings = () => {
  const { t } = useTranslation();
  const { meetings, searchTerm, setSearchTerm, errorModal, setErrorModal, errors, updateAttendance } =
    useScheduledMeetings();
  const [editingId, setEditingId] = useState(null);

  return (
    <div className="flex flex-col h-screen bg-secondaryBg">
      <AdminMobileTopbar title={t("dashboard.scheduledMeetings")} />

      <div className="flex-1 overflow-y-auto px-4 py-4 flex flex-col gap-3">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={t("agent.mobile.searchPlaceholder", "Nombre, correo o empresa...")}
          className="w-full bg-white text-xs border border-gray-200 rounded-lg px-3 py-2.5"
        />

        {meetings.map((m) => (
          <div key={m.meetingLogId} className="bg-white rounded-xl border border-gray-200 p-3.5">
            <div className="flex justify-between items-start mb-2">
              <div>
                <p className="text-[13px] font-bold text-primary m-0">{m.name} {m.lastName}</p>
                <p className="text-[11px] text-gray-400 m-0">{m.company}</p>
              </div>
              <span className="text-[10px] font-bold text-secondary bg-lightBlue px-2 py-1 rounded-full flex-shrink-0">
                {m.date} · {m.time}
              </span>
            </div>
            <p className="text-[11px] text-gray-500 mb-2">{m.mail}</p>

            {editingId === m.meetingLogId ? (
              <div className="flex gap-2">
                <button
                  type="button"
                  onClick={async () => {
                    const ok = await updateAttendance(m.meetingLogId, "Yes");
                    if (ok) setEditingId(null);
                  }}
                  className="flex-1 text-xs font-bold text-white bg-green-600 rounded-lg py-2"
                >
                  {t("agent.noteInfo.yes")}
                </button>
                <button
                  type="button"
                  onClick={async () => {
                    const ok = await updateAttendance(m.meetingLogId, "No");
                    if (ok) setEditingId(null);
                  }}
                  className="flex-1 text-xs font-bold text-white bg-red-500 rounded-lg py-2"
                >
                  No
                </button>
                <button
                  type="button"
                  onClick={() => setEditingId(null)}
                  className="flex-1 text-xs font-bold text-primary bg-secondaryBg rounded-lg py-2"
                >
                  {t("button.cancel")}
                </button>
              </div>
            ) : (
              <button
                type="button"
                onClick={() => setEditingId(m.meetingLogId)}
                className={`w-full text-xs font-bold rounded-lg py-2 ${
                  m.attended === "Yes"
                    ? "bg-green-100 text-green-700"
                    : m.attended === "No"
                    ? "bg-red-100 text-red-700"
                    : "bg-secondaryBg text-gray-500"
                }`}
              >
                {m.attended === "Yes" ? t("agent.noteInfo.yes") : m.attended === "No" ? "No" : t("dashboard.pending", "Pendiente")}
              </button>
            )}
          </div>
        ))}
      </div>

      {errorModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
          <div className="bg-white rounded-2xl p-6 flex flex-col items-center text-center max-w-sm">
            <p className="font-bold text-primary mb-2">{t("admin.userError.head")}</p>
            {errors.submit && <p className="text-sm text-gray-500 mb-4">{errors.submit}</p>}
            <button
              type="button"
              onClick={() => setErrorModal(false)}
              className="text-sm font-bold text-white bg-secondary rounded-lg px-4 py-2"
            >
              {t("admin.userError.btn")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileScheduledMeetings;
